<ng-container *ngFor="let item of contextList">
    <span *ngIf="item.type==0 else emoji">{{item.value}}</span>
    <ng-template #emoji>
        <img src="{{item.value}}" />
    </ng-template>
</ng-container>